import PubSub from "underpub-js";

var Hero = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

Hero.prototype.init = function(){

  // hooking up our video button
  $("[data-button-video]").on("click", function(){
    PubSub.publish("showVideoOverlay");
  });

};

export default  Hero;
